import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_BASE_URL } from "../../Config/Config";

export const fetchClassData = createAsyncThunk("api/class", async () => {
  const response = await fetch(
    `${API_BASE_URL}/prism/api/v1/get-classes`
  );
  const data = await response.json();
  return data;
});

const classSlice = createSlice({
  name: "class",
  initialState: {
    classData: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchClassData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClassData.fulfilled, (state, action) => {
        state.loading = false;
        state.classData = action.payload;
      })
      .addCase(fetchClassData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default classSlice.reducer;
